export const countries =  [
	{id:'AF', name:'Afganistan'},
	{id:'AX', name:'Alandski otoki'},
	{id:'AL', name:'Albanija'},
	{id:'DZ', name:'Alžirija'},
	{id:'AS', name:'Ameriška Samoa'},
	{id:'AD', name:'Andora'},
	{id:'AO', name:'Angola'},
	{id:'AI', name:'Angvila'},
	{id:'AQ', name:'Antarktika'},
	{id:'AG', name:'Antigva in Barbuda'},
	{id:'AR', name:'Argenitna'},
	{id:'AM', name:'Armenija'},
	{id:'AW', name:'Aruba'},
	{id:'AU', name:'Avstralija'},
	{id:'AT', name:'Avstrija'},
	{id:'AZ', name:'Azerbajdžan'},
	{id:'BS', name:'Bahami'},
	{id:'BH', name:'Bahrajn'},
	{id:'BD', name:'Bangladeš'},
	{id:'BB', name:'Barbados'},
	{id:'BY', name:'Belorusija'},
	{id:'BE', name:'Belgija'},
	{id:'BZ', name:'Belize'},
	{id:'BJ', name:'Benin'},
	{id:'BM', name:'Bermudi'},
	{id:'BT', name:'Butan'},
	{id:'BO', name:'Bolivija'},
	{id:'BQ', name:'Otočje Bonaire, Sv. Eustatij in Saba'},
	{id:'BA', name:'Bosna in Hercegovina'},
	{id:'BW', name:'Bocvana'},
	{id:'BV', name:'Bouvetov otok'},
	{id:'BR', name:'Brazilija'},
	{id:'IO', name:'Britansko ozemlje v Indijskem oceanu'},
	{id:'BN', name:'Brunej'},
	{id:'BG', name:'Bolgarija'},
	{id:'BF', name:'Burkina Faso'},
	{id:'BI', name:'Burundi'},
	{id:'KH', name:'Kambodža'},
	{id:'CM', name:'Kamerun'},
	{id:'CA', name:'Kanada'},
	{id:'CV', name:'Kapverdski otoki (Zelenortski otoki)'},
	{id:'KY', name:'Kajmanski otoki'},
	{id:'CF', name:'Srednjeafriška republika'},
	{id:'TD', name:'Čad'},
	{id:'CL', name:'Čile'},
	{id:'CN', name:'Kitajska'},
	{id:'CX', name:'Božični otok'},
	{id:'CC', name:'Kokosovi in Keelingovi otoki'},
	{id:'CO', name:'Kolumbija'},
	{id:'KM', name:'Komori'},
	{id:'CG', name:'Kongo'},
	{id:'CD', name:'Demokratična republika Kongo'},
	{id:'CK', name:'Cookovi otoki'},
	{id:'CR', name:'Kostarika'},
	{id:'CI', name:'Slonokoščena obala'},
	{id:'HR', name:'Hrvaška'},
	{id:'CU', name:'Kuba'},
	{id:'CW', name:'Kurasao'},
	{id:'CY', name:'Ciper'},
	{id:'CZ', name:'Češka'},
	{id:'DK', name:'Danska'},
	{id:'DJ', name:'Džibuti'},
	{id:'DM', name:'Dominika'},
	{id:'DO', name:'Dominikanska republika'},
	{id:'EC', name:'Ekvador'},
	{id:'EG', name:'Egipt'},
	{id:'SV', name:'Salvador'},
	{id:'GQ', name:'Ekvatorialna Gvineja'},
	{id:'ER', name:'Eritreja'},
	{id:'EE', name:'Estonija'},
	{id:'ET', name:'Etiopija'},
	{id:'FK', name:'Falkalndski otoki'},
	{id:'FO', name:'Ferski otoki'},
	{id:'FJ', name:'Fidži'},
	{id:'FI', name:'Finska'},
	{id:'FR', name:'Francija'},
	{id:'GF', name:'Francoska Gvajana'},
	{id:'PF', name:'Francoska Polinezija'},
	{id:'TF', name:'Francoska južna ozemlja'},
	{id:'GA', name:'Gabon'},
	{id:'GM', name:'Gambija'},
	{id:'GE', name:'Gruzija'},
	{id:'DE', name:'Nemčija'},
	{id:'GH', name:'Gana'},
	{id:'GI', name:'Gibraltar'},
	{id:'GR', name:'Grčija'},
	{id:'GL', name:'Grenlandija'},
	{id:'GD', name:'Grenada'},
	{id:'GP', name:'Guadeloupe'},
	{id:'GU', name:'Guam'},
	{id:'GT', name:'Gvatemala'},
	{id:'GG', name:'Otok Guernsey'},
	{id:'GN', name:'Gvineja'},
	{id:'GW', name:'Gvineja-Bissau'},
	{id:'GY', name:'Gvajana'},
	{id:'HT', name:'Haiti'},
	{id:'HM', name:'Otok Heard in otočje McDonald'},
	{id:'VA', name:'Vatikan'},
	{id:'HN', name:'Honduras'},
	{id:'HK', name:'Hong Kong'},
	{id:'HU', name:'Madžarska'},
	{id:'IS', name:'Islandija'},
	{id:'IN', name:'Indija'},
	{id:'ID', name:'Indonezija'},
	{id:'IR', name:'Iran'},
	{id:'IQ', name:'Irak'},
	{id:'IE', name:'Irska'},
	{id:'IM', name:'Otok Man'},
	{id:'IL', name:'Izrael'},
	{id:'IT', name:'Italija'},
	{id:'JM', name:'Jamajka'},
	{id:'JP', name:'Japonska'},
	{id:'JE', name:'Otok Jersey'},
	{id:'JO', name:'Jordanija'},
	{id:'KZ', name:'Kazahstan'},
	{id:'KE', name:'Kenija'},
	{id:'KI', name:'Kiribati'},
	{id:'KP', name:'Severna Koreja'},
	{id:'KR', name:'Južna Koreja'},
	{id:'KW', name:'Kuvajt'},
	{id:'KG', name:'Kirgizistan (Kirgizija)'},
	{id:'LA', name:'Laos'},
	{id:'LV', name:'Latvija'},
	{id:'LB', name:'Libanon'},
	{id:'LS', name:'Lesoto'},
	{id:'LR', name:'Liberija'},
	{id:'LY', name:'Libija'},
	{id:'LI', name:'Lihtenštajn'},
	{id:'LT', name:'Litva'},
	{id:'LU', name:'Luksemburg'},
	{id:'MO', name:'Makao'},
	{id:'MK', name:'Makedonija'},
	{id:'MG', name:'Madagaskar'},
	{id:'MW', name:'Malavi'},
	{id:'MY', name:'Malezija'},
	{id:'MV', name:'Maldivi'},
	{id:'ML', name:'Mali'},
	{id:'MT', name:'Malta'},
	{id:'MH', name:'Maršalovi otoki'},
	{id:'MQ', name:'Martinik'},
	{id:'MR', name:'Mavretanija'},
	{id:'MU', name:'Mauricius (Moris)'},
	{id:'YT', name:'Francoska skupnost Mejot'},
	{id:'MX', name:'Mehika'},
	{id:'FM', name:'Mikronezija'},
	{id:'MD', name:'Moldavija'},
	{id:'MC', name:'Monako'},
	{id:'MN', name:'Mongolija'},
	{id:'ME', name:'Črna Gora'},
	{id:'MS', name:'Montserat'},
	{id:'MA', name:'Maroko'},
	{id:'MZ', name:'Mozambik'},
	{id:'MM', name:'Mjanmar'},
	{id:'NA', name:'Namibija'},
	{id:'NR', name:'Nauru'},
	{id:'NP', name:'Nepal'},
	{id:'NL', name:'Nizozemska'},
	{id:'NC', name:'Nova Kaledonija'},
	{id:'NZ', name:'Nova Zelandija'},
	{id:'NI', name:'Nikaragva'},
	{id:'NE', name:'Niger'},
	{id:'NG', name:'Nigerija'},
	{id:'NU', name:'Niu'},
	{id:'NF', name:'Otok Norflok'},
	{id:'MP', name:'Severni Marianski otoki'},
	{id:'NO', name:'Norveška'},
	{id:'OM', name:'Oman'},
	{id:'PK', name:'Pakistan'},
	{id:'PW', name:'Palau'},
	{id:'PS', name:'Palestina'},
	{id:'PA', name:'Panama'},
	{id:'PG', name:'Papua Nova Gvineja'},
	{id:'PY', name:'Paragvaj'},
	{id:'PE', name:'Peru'},
	{id:'PH', name:'Filipini'},
	{id:'PN', name:'Pitcairnovi otoki'},
	{id:'PL', name:'Poljska'},
	{id:'PT', name:'Portugalska'},
	{id:'PR', name:'Portoriko'},
	{id:'QA', name:'Katar'},
	{id:'RE', name:'Francoska skupnost Reunion'},
	{id:'RO', name:'Romunija'},
	{id:'RU', name:'Ruska federacija'},
	{id:'RW', name:'Ruanda'},
	{id:'BL', name:'Sveti Bartolomej'},
	{id:'SH', name:'Sveta Helena'},
	{id:'KN', name:'Sveti Kits in Nevis'},
	{id:'LC', name:'Sveta Lucija'},
	{id:'MF', name:'Otok svetega Martina'},
	{id:'PM', name:'Sveta Pierre in Miquelon'},
	{id:'VC', name:'Sveti Vincent in Grenadini'},
	{id:'WS', name:'Samoa'},
	{id:'SM', name:'San Marino'},
	{id:'ST', name:'Sao Tome in Principe'},
	{id:'SA', name:'Savdska Arabija'},
	{id:'SN', name:'Senegal'},
	{id:'RS', name:'Srbija'},
	{id:'SC', name:'Sejšeli'},
	{id:'SL', name:'Siera Leone'},
	{id:'SG', name:'Singapur'},
	{id:'SX', name:'Otok svetega.Martina (Nizozemska)'},
	{id:'SK', name:'Slovaška'},
	{id:'SI', name:'Slovenija'},
	{id:'SB', name:'Solomonovi otoki'},
	{id:'SO', name:'Somalija'},
	{id:'ZA', name:'Južna afrika'},
	{id:'GS', name:'Južna Georgia in Južni Sandwichevi otoki'},
	{id:'SS', name:'Južni Sudan'},
	{id:'ES', name:'Španija'},
	{id:'LK', name:'Šri Lanka'},
	{id:'SD', name:'Sudan'},
	{id:'SR', name:'Surinam'},
	{id:'SJ', name:'Svalbard in Jan Majen '},
	{id:'SZ', name:'Svazi'},
	{id:'SE', name:'Švedska'},
	{id:'CH', name:'Švica'},
	{id:'SY', name:'Sirija'},
	{id:'TW', name:'Tajvan'},
	{id:'TJ', name:'Tadžikistan'},
	{id:'TZ', name:'Tanzanija'},
	{id:'TH', name:'Tajska'},
	{id:'TL', name:'Vzhodni Timor'},
	{id:'TG', name:'Togo'},
	{id:'TK', name:'Tokelau'},
	{id:'TO', name:'Tonga'},
	{id:'TT', name:'Trinidad in Tobago'},
	{id:'TN', name:'Tunizija'},
	{id:'TR', name:'Turčija'},
	{id:'TM', name:'Turkmenistan'},
	{id:'TC', name:'Tirški in Kajkoški otoki'},
	{id:'TV', name:'Tuvalu'},
	{id:'UG', name:'Uganda'},
	{id:'UA', name:'Ukrajina'},
	{id:'AE', name:'Združeni Arabski Emirati'},
	{id:'GB', name:'Velika Britanija'},
	{id:'US', name:'Združene države Amerike'},
	{id:'UM', name:'ZDA zunanji otoki'},
	{id:'UY', name:'Urugvaj'},
	{id:'UZ', name:'Uzbekistan'},
	{id:'VU', name:'Republika Vanuatu'},
	{id:'VE', name:'Venezuela'},
	{id:'VN', name:'Vietnam'},
	{id:'VG', name:'Britanski Deviški otoki'},
	{id:'VI', name:'Ameriški Deviški otoki'},
	{id:'WF', name:'Otočje Valis in Futuna'},
	{id:'EH', name:'Zahodna Sahara'},
	{id:'YE', name:'Jemen'},
	{id:'ZM', name:'Zambija'},
	{id:'ZW', name:'Zimbabve'}
]